import { toggleObjectFilter } from '~/utils/filter/selection'

export function useFacetFilter(filter: Ref<{ value: string, label: string }[]>, options: MaybeRefOrGetter<{ value: string, label: string }[]>, countWith: (option: { value: string, label: string }) => number) {
  const selected = computed(() => filter.value.map(f => f.value))

  function toggle(value: string, checked: boolean) {
    const label = toValue(options).find(option => option.value === value)?.label ?? value
    filter.value = toggleObjectFilter(filter.value, value, checked, label)
  }

  // Order is the surface's own (alphabetical); the collapsed view picks by count
  const facetOptions = computed(() => {
    return toValue(options).map(option => ({
      ...option,
      count: countWith(option),
    }))
  })

  return { toggle, selected, facetOptions }
}